<template>
    <div class="border-primary card p-10">
        <h5 class="mb-10">Bliggit Anbindung</h5>
        <div v-if="!bliggitStore || changeBliggit">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Bliggit Username / E-Mail</label>
                        <input class="form-control" v-model="username" required>
                        <small class="form-text text-danger" v-if="errors['payload']">Geben Sie Ihren
                            Benutzernamen ein</small>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Bliggit Password</label>
                        <input class="form-control" v-model="password" type="password" required>
                        <small class="form-text text-danger" v-if="errors['payload']">Geben Sie Ihr Passwort
                            ein</small>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label>Wählen Sie das Geschäft aus, welches mit Bliggit verknüpft werden soll</label>
                <VueMultiselect
                    v-model="selectedStores"
                    placeholder="Geschäft auswählen ..." :options="storeOptions"
                    track-by="label"
                    :custom-label="(store) => store.label"
                ></VueMultiselect>
                <small class="form-text text-danger" v-if="errors['store_uuid']">Wählen Sie das ein Geschäft
                    aus</small>
            </div>
            <button class="btn btn-primary" @click="submitBliggit()">
                <span class="svg-icon svg-icon-md"><i class="text-white fas fa-save"></i></span>
                Speichern
            </button>
        </div>
        <div v-if="bliggitStore && !changeBliggit">
            <div class="alert alert-custom alert-light-primary" role="alert">
                <div class="alert-icon">
                    <i class="fa fa-exclamation-triangle"/>
                </div>
                <div class="alert-text">
                    <div class="text-lg font-weight-bold text-body">Sie haben bereits ein Geschäft mit Bliggit verknüpft:
                    </div>
                    <h5 class="my-4 text-primary">{{ bliggitStore }}</h5>
                    <div class="text-lg font-weight-bold text-body"> Wollen Sie die Verknüpfung einem anderen Geschäft zuweisen?</div>
                    <button class="btn btn-primary mt-5" @click="changeBliggit = true">
                        <span class="svg-icon svg-icon-md"><i class="text-white fas fa-exchange-alt"></i></span>
                        Ändern
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect';

export default {
    components: {
        VueMultiselect,
    },
    props: {
        existingAccounts: [Object, Array],
        stores: Array,
    },
    data() {
        return {
            username: '',
            password: '',
            storeOptions: [],
            selectedStores: Object,
            errors: {},
            changeBliggit: false,
        };
    },
    computed: {
        bliggitStore() {
            let storeUuid = 'bliggit' in this.existingAccounts ? this.existingAccounts['bliggit'] : null;
            let storeLabel = null;
            if (storeUuid) {
                this.stores.forEach(function (store) {
                    if (store.id === storeUuid) {
                        storeLabel = store.attributes.name + ' - ' + store.attributes.address.street1
                    }
                });
            }
            return storeLabel;
        },
        payload() {
            if (!this.username || !this.password) {
                return null;
            }
            return {username: this.username, password: this.password};
        },
    },
    mounted() {
        this.stores.forEach((item) => {
            this.storeOptions.push(
                {
                    uuid: item.id,
                    label: item.attributes.name + ' - ' + item.attributes.address.street1,
                });
        });
    },
    methods: {
        submitBliggit() {
            this.errors = {};
            if (!this.changeBliggit) {
                this.$inertia.post(this.$route('store-settings.store'), {
                    store_uuid: this.selectedStores.uuid,
                    provider: 'bliggit',
                    payload: this.payload,
                }, {
                    onSuccess: () => {
                        toastr.success(`Ihr Geschäft wurde mit Ihrem Konto bei Bliggit verknüpft`);
                    },
                    onError: (error) => {
                        this.errors = error.response.data.errors;
                        toastr.error('Bitte überprüfen Sie Ihre Angaben');
                    }
                });
            } else {
                this.$inertia.post(this.$route('store-settings.update'), {
                    store_uuid: this.selectedStores.uuid,
                    provider: 'bliggit',
                    payload: this.payload,
                }, {
                    onSuccess: () => {
                        toastr.success(`Ihre Änderungen wurden übernommen`);
                    },
                    onError: (error) => {
                        this.errors = error.response.data.errors;
                        toastr.error('Bitte überprüfen Sie Ihre Angaben');
                    }
                });
            }
        },
    },
};
</script>
